// extracted by mini-css-extract-plugin
export default {"tableHeadMain":"TableHead_tableHeadMain__M2Rpt","tableHeadSecondary":"TableHead_tableHeadSecondary__7g5x4"};